import styled from '@emotion/styled';

export const AnalyticsContentWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  padding: '27px 53px 47px 49px',
  background: theme.palette.custom.white,
  borderRadius: '24px',
  boxShadow: '0px 12px 42px -4px rgba(0, 0, 0, 0.12), 0px 8px 18px -6px rgba(0, 0, 0, 0.12)',
  overflow: 'auto',
}));
